interface IProps {
    isChecked: boolean;
    color: string;
    className: string;
    onChange: () => void;
}

export const RadioButton = ({ onChange, isChecked, className, color }: IProps) => {
    return (
        <div
            data-testid="medbox-hue-radio-button"
            onClick={onChange}
            className={`flex h-[22px] w-[22px] cursor-pointer items-center justify-center rounded-full bg-white lg:h-[30px] lg:w-[30px] ${className}`}
        >
            <div
                className={`h-[14px] w-[14px] rounded-full lg:h-[22px] lg:w-[22px] opacity-${isChecked ? '100' : '0'} ease transition duration-500`}
                style={{ backgroundColor: color }}
            />
        </div>
    );
};
